import React, { SyntheticEvent, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import AlarmCentralEvents from './_components/AlarmCentralEvents';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';
import AlarmCentralList from './_components/AlarmCentralList';
import { useTranslation } from 'react-i18next';

const AlarmCentralMainPage = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState('1');
  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <HeaderDashboard></HeaderDashboard>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            width: '50%',
            mt: '-50px',
          }}
        >
          <TabList onChange={handleChange}>
            <Tab label={t('alarmCentral.tabCentrals')} value="1" />
            <Tab label={t('alarmCentral.tabEvents')} value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <AlarmCentralList />
        </TabPanel>
        <TabPanel value="2">
          <AlarmCentralEvents />
        </TabPanel>
      </TabContext>
    </>
  );
};

export default AlarmCentralMainPage;
